import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeInHours'
})
export class TimeInHoursPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    return (value/3600).toFixed(2) + ' h';
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/time-in-hours.pipe.ts